import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";

const modeloDatos = {
 
     clienteID : "",
        empresaId : "",
        nombre : "",
        alias : "",
        direccion : "",
        telefono1 : "",
        telefono2 : "",
        celular : "",
        email : "",
        crupoSecuenciaid : "",
        gobiernoNumero : "",
        grupoID : "",
        monedaID : "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
   recordID : 0
}

const Cliente = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "CXC/listaClientes" + "/" + correo);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
       
           
           
        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.especialistaID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/GuardarEspecialista", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/EditarEspecialista", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.clienteID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.nombre,
            sortable: true,
        },
       
      
        {
            name: 'Telefono',
            selector: row => row.telefono1,
            sortable: true,
            //cell: row => {
            //    let clase;
            //    clase = row.activa ? "badge badge-info p-2" : "badge badge-danger p-2"
            //    return (
            //        <span className={clase}>{row.activa ? "Activo" : "No Activo"}</span>
            //    )
            //}
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Cliente
                </CardHeader>
                <CardBody>
                    <Button hidden={ true} color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Cliente</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader>
                    Mantenimiento de Especialistas
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <div className="d-flex justify-content-start">
                            <div className="p-2">
                                <Label>Nombre </Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={tabla.nombre} />
                            </div>
                            <div className="p-2">
                                <Label>Telefono</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                            </div>
                        </div>
                    </FormGroup>
                   
                    <FormGroup>
                        <Label>Estado</Label>

                        <Input bsSize="sm" type={"select"} name="activa" onChange={handleChange} value={tabla.activa} >
                            <option value={true}>Activo</option>
                            <option value={false}>No Activo</option>
                        </Input>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Cliente;